import React, {useEffect, useState} from 'react';
import QRCode from 'qrcode';
import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import styles from './BookingSuccess.module.css';

export default function BookingSuccess({open = false, bookingCode = '', onClose = () => {}}) {
    const {locale} = useRouter();
    const [qrBase64, setQrBase64] = useState('');

    // 1) ALWAYS run hooks (do not early-return before them)
    useEffect(() => {
        if (!bookingCode) return;
        QRCode.toDataURL(
            bookingCode,
            {
                type: 'image/png',
                width: 140,
                margin: 2,
                color: {dark: '#000000', light: '#ffffff'},
            },
            (err, url) => {
                if (!err) setQrBase64(url);
            },
        );
    }, [bookingCode]);

    useEffect(() => {
        const esc = e => e.key === 'Escape' && onClose();
        window.addEventListener('keydown', esc);
        return () => window.removeEventListener('keydown', esc);
    }, [onClose]);

    const handleBackdrop = e => {
        if (e.target === e.currentTarget) onClose();
    };

    // 2) Gate rendering AFTER hooks
    if (!open) return null;

    return (
        <div
            className={styles['booking-success-overlay']}
            role="dialog"
            aria-modal="true"
            aria-label="Booking success"
            onClick={handleBackdrop}>
            <div className={styles['booking-success']}>
                <div className={styles['booking-success__info']}>
                    <h1 className={styles['booking-success__title']}>
                        {getLocaleContent(locale, 'page.booking-form.success-message')}
                    </h1>
                    <p className={styles['booking-success__text']}>
                        {getLocaleContent(locale, 'page.booking-form.success-message2')}
                        <br />
                        {getLocaleContent(locale, 'page.booking-form.success-message3')}
                    </p>
                    <div className={styles['section-qrcode']}>
                        <div className={styles['booking-success__code']}>
                            <span>{getLocaleContent(locale, 'page.booking-form.success-message4')}</span>
                            <strong>{bookingCode}</strong>
                        </div>

                        <div className={styles['booking-success__qr']}>
                            {qrBase64 && <img id="booking-success-qr" src={qrBase64} alt="QR Code" />}
                        </div>

                        <button
                            className={styles['booking-success__button']}
                            onClick={() => {
                                const qrImg = document.getElementById('booking-success-qr');
                                if (!qrImg) return;
                                const link = document.createElement('a');
                                link.href = qrImg.src;
                                link.download = 'qr-code.png';
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            }}>
                            {getLocaleContent(locale, 'page.booking-form.success-message5')}
                        </button>
                    </div>
                </div>

                <div className={styles['booking-success__thankyou']}>
                    <div className={styles['thankyou-corner']}>
                        <img src="/bw_image/corner-shape.svg" alt="" />
                    </div>
                    <button className={styles['booking-success__close']} aria-label="Close" onClick={onClose}>
                        <img src="/bw_image/close.svg" alt="" aria-hidden="true" />
                    </button>
                    {/* <div className={styles['thankyou-content']}>
                        <h2 className={styles['thankyou-content__title']}>Thank you!</h2>
                        <p className={styles['thankyou-content__text']}>CTCP Tập đoàn Bệnh viện TNH</p>
                    </div> */}
                </div>
            </div>
        </div>
    );
}
